import React, { Component } from 'react';
import {goCommonPage,setlog} from '@modules/58m';
import GuessLike from './GuessLike';
import {isLogin} from "@modules/58m";
import prdApi from "@config/api";

export default class Header extends Component {
  constructor(props){
    super();
    this.state={
      isShowSetOption:false,
      isShowLogoTip:false,
      isShowGuessLike:false,//点击小聘大脑袋 显示 悬浮猜你想问模块
    }
    this.moreOpr = this.moreOpr.bind(this);
  }
  switchSetOption= ()=>{
    setlog("mchatbot_tool_click");
    const isShowSetOption = this.state.isShowSetOption;
    let _this = this;
    if(!isShowSetOption){
      //显示
      this.setState({
        isShowSetOption:true
      })
    }else{
      this.refs.moreOption.classList.add("animate-fade");
      setTimeout(function(){
        _this.setState({
          isShowSetOption:false
        })
      },800)
    }
  }
  goBack=(e)=>{
    window.history.go(-1);
  }
  goShare=()=>{
    return;
  };
  async moreOpr (type,event){
    const state = await isLogin();
    this.setState({
      isShowSetOption:false
    })
    switch(type){
      case "userSet":
      setlog("mchatbot_toolset_click");
      if(state == 1){
        goCommonPage(prdApi.jumpUrl.set);
        //window.location.href = prdApi.jumpUrl.set;
      }else{
        goCommonPage("https://m.m.58.com/login?path="+encodeURIComponent(prdApi.jumpUrl.set));
        //window.location.href = "https://m.m.58.com/login?path="+encodeURIComponent(prdApi.jumpUrl.set);
      }
      break;
      case "zpindex"://引导app 不去首页
      setlog("mchatbot_downapp_click");
      goCommonPage("https://down.58.com/zt/callappback.html?pagetype=common&tradeline=core&pid=2281&url="+encodeURIComponent(prdApi.jumpUrl.appchatbotindex));
      //window.location.href = "https://down.58.com/zt/callappback.html?pagetype=common&pid=2281&url="+encodeURIComponent(prdApi.jumpUrl.appchatbotindex);
      break;
      case "userfeedback":
      setlog("mchatbot_toolfeedback_click");
      if(state == 1){
        goCommonPage(prdApi.jumpUrl.cvip);
        //window.location.href = prdApi.jumpUrl.cvip;
      }else{
        goCommonPage("https://m.m.58.com/login?path="+encodeURIComponent(prdApi.jumpUrl.cvip));
        //window.location.href = "https://m.m.58.com/login?path="+encodeURIComponent(prdApi.jumpUrl.cvip);
      }
      break;
      default:
      return;
    }
  };
  switchGuessLike=()=>{
    this.setState({
      isShowGuessLike:!this.state.isShowGuessLike
    })
  }
  componentDidMount(){
    if(!localStorage.getItem("zpchatbot-logoClickTip")){
      //没有提示过 绑定滚定
      let _this = this;
      window.____globalCommonObjforFE.eventEmitter.once('showLogoClickTip', function() { 
        console.log('showLogoClickTip 事件触发'); 
        localStorage.setItem("zpchatbot-logoClickTip",1)
        _this.setState({isShowLogoTip:true});
        setTimeout(function(){
          _this.setState({isShowLogoTip:false});
        },3000);
    });
    }
  }
  render() {
    const {isShowSetOption,isShowLogoTip,isShowGuessLike} = this.state;
    const isShowGoBack = (this.props.isShowGoBack !==undefined)?this.props.isShowGoBack:true;
    return (
        <div className="module-header">
          <div className="opr-wrap">
            <div className="opr-content">
              {isShowGoBack?
                <span className="goBack iconfont icon-back_nav_icx" onClick={this.goBack}></span>:null
              }
              <span className="logo" onClick={this.switchGuessLike}>
                {isShowLogoTip?
                  <span className="logo-tip">点小聘可以展开所有服务</span>:null}
              </span>
              <span className="userset" onClick={this.switchSetOption}>更多</span>
              {/* <span className="share iconfont icon-share_nav_icx" onClick={this.goShare}></span> */}
            </div>
          {
            isShowSetOption?
            <div className="more-option" ref="moreOption">
            <ul className="option-wrap">
              <li className="option-item" onClick={this.moreOpr.bind(this,'userSet')}>
                <span className="iconfont icon-set__robot_icx"><span className="txt">设置</span></span>
              </li>
              {
                window._SOURCE === "ganji" 
                ? null 
                : <li className="option-item" onClick={this.moreOpr.bind(this,'zpindex')}>
                  <span className="iconfont icon-home_robot_icx"><span className="txt">去App体验</span></span>
                </li>
              }
              <li className="option-item" onClick={this.moreOpr.bind(this,'userfeedback')}>
                <span className="iconfont icon-edit_robot_icx"><span className="txt">意见反馈</span></span>
              </li>
            </ul>
            <div className="more-option-mask" onClick={this.switchSetOption}></div>
          </div>:null
          }
          </div>
          {
            isShowGuessLike?
            <div className="module-guesslike-wrap">
              <div className="module-guesslike-mask" onClick={this.switchGuessLike}></div>
              <GuessLike></GuessLike>
              <div className='btn-up'><span className="pic-arrorup"></span></div>
            </div>:null
          }
        </div>

    );
  }
}
